import gb from "@app/images/flags/gb.svg";
import de from "@app/images/flags/de.svg";
import fr from "@app/images/flags/fr.svg";
import it from "@app/images/flags/it.svg";

export const LANGUAGE_LABELS = {
  EN: {
    label: "English",
    icon: gb,
  },
  DE: {
    label: "Deutsch",
    icon: de,
  },
  FR: {
    label: "Français",
    icon: fr,
  },
  IT: {
    label: "Italiano",
    icon: it,
  },
};
